import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import Pagination from '../layouts/pagination.jsx';
import ViewEmployees from './sections/view';
import ExcelExport from './sections/export.jsx';
import Swal from 'sweetalert2';


const InactiveEmployees = () => {
    const [employees, setEmployees] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);    // Pagination starts at 0
    const [pageCount, setPageCount] = useState(0);        // Total number of pages
    const [employeeId, setEmployeeId] = useState(null);
    const [filterID, setFilterID] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [roles, setRoles] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [selectedRole, setSelectedRole] = useState('');
    const [selDepartment, setSelDepartment] = useState('');
    const [exportEmployees, setExportEmployees] = useState([]);

    const fetchExportEmployees = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/users?users=inactive`)
            .then(response => {
                setExportEmployees(response.data.data);
            })
            .catch(error => {
                console.error("Error fetching employees!", error);
                setExportEmployees([]);
            });
    };

    const fetchEmployees = async (currentPage) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/users?users=inactive&page=${currentPage + 1}`)
            .then(response => {
                setEmployees(response.data.data);
                setPageCount(Math.ceil(response.data.meta.pagination.total / response.data.meta.pagination.per_page));
            })
            .catch(error => {
                console.error("Error fetching employees!", error);
                setEmployees([]);
            });
    };

    const fetchRoles = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/role`)
            .then(response => {
                setRoles(response.data.data);
            })
            .catch(error => {
                setRoles([]);
            });
    };

    const fetchDepartments = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/department`)
            .then(response => {
                setDepartments(response.data.data);
            })
            .catch(error => {
                setDepartments([]);
            });
    };

    useEffect(() => { 
        fetchEmployees(currentPage);
        fetchRoles();
        fetchDepartments();
        fetchExportEmployees();
    }, [currentPage]);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };
    
    // Search input handler
    const filteredItems = employees.filter((item) => {
        var role = parseInt(selectedRole);
        var department = parseInt(selDepartment);
        var text = filterText.toLowerCase();
        const matchesID = filterID ? item.emp_id === parseInt(filterID) : true;
        const matchesName = item.name.toLowerCase().includes(text);
        const matchesEmail = item.email.toLowerCase().includes(text);
        const matchesPhone = String(item.phone_number).includes(text);
        const matchesRole = role ? parseInt(item.role_id) === role : true;
        const matchesDep = department ? item.department_id === department : true;
        return matchesID && (matchesName || matchesEmail || matchesPhone) && matchesRole && matchesDep;
    });
    
    const changeEmail = async ({employeeId}) => {
        let email = null;

        const result = await Swal.fire({
            title: 'Are you sure you want to change email?',
            icon: 'warning',
            input: 'email',
            inputPlaceholder: 'Enter email here...',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '&nbsp;&nbsp;&nbsp; Yes &nbsp;&nbsp;&nbsp;',
            inputValidator: (value) => {
                if (!value) {
                    return 'please enter email!';
                }
            }
        });

        if (result.isConfirmed) {
            email = result.value;
        } else {
            return;
        }
        

        axiosInstance.post(`${process.env.REACT_APP_API_URL}/employee/update_email/${employeeId}`,{
                email: email
            })
            .then(({data})=>{
                Swal.fire({icon:"success",text:data.message});
                fetchEmployees();
            }).catch(({response:{data}})=>{
                Swal.fire({text:data.message, icon:"error"});
            });
    };

    return (
        <>
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center timeLog">
                        <div className="col">
                            <h3 className="page-title">Inactive Employees</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Inactive Employees</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-2 mb-3">
                        <input className="form-control" type="text"
                            placeholder="Search Emp ID..." aria-label="Search Input"
                            value={filterID} onChange={(event)=> {
                                setFilterID(event.target.value)
                            }} />
                    </div>
                    <div className="col-md-3 mb-3">
                        <input className="form-control" type="text"
                            placeholder="Search Employee..." aria-label="Search Input"
                            value={filterText} onChange={(event)=> {
                                setFilterText(event.target.value)
                            }} />
                    </div>                    
                    <div className="col-md-2 mb-3">
                        <select className="form-control"
                            value={selDepartment}
                            onChange={(event) => {setSelDepartment(event.target.value)}}>
                                <option value="">Select Department</option>
                                {departments.map(dep => (
                                    <option key={dep.id} value={dep.id}>{dep.name}</option>
                                ))}
                        </select>
                    </div>
                    <div className="col-md-2 mb-3">
                        <select className="form-control"
                            value={selectedRole}
                            onChange={(event) => {setSelectedRole(event.target.value)}}>
                                <option value="">Select Role</option>
                                {roles.map(role => (
                                    <option key={role.id} value={role.id}>{role.name}</option>
                                ))}
                        </select>
                    </div>
                    <div className="col-md-3 mb-3 empInput" align="right">
                        <ExcelExport data={filteredItems} fileName="InactiveEmployees" />
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table ">
                                        <thead>
                                            <tr>
                                                <th>Emp ID</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Phone Number</th>
                                                <th>Joining Date</th>
                                                <th>End Date</th>
                                                <th>Department</th>
                                                <th>Role Name</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredItems.length > 0 ? (
                                                    filteredItems.map((employee) => (
                                                        <tr key={employee.id}>
                                                            <td>{employee.emp_id}</td>
                                                            <td>{employee.name}</td>
                                                            <td>{employee.email}</td>
                                                            <td>{employee.phone_number}</td>
                                                            <td>{employee.joined_date}</td>
                                                            <td>{employee.updated_at}</td>
                                                            <td>{employee.department}</td>
                                                            <td>{employee.role_name}</td>
                                                            <td className="text-end">
                                                                <div className="dropdown dropdown-action">
                                                                    <Link to="#" className="action-icon dropdown-toggle"
                                                                        data-bs-toggle="dropdown" aria-expanded="false"
                                                                            onClick={() => setEmployeeId(`${employee.id}`)}>
                                                                            <i className="material-icons">more_vert</i></Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                            data-bs-target={`#view_employee_${employee.id}`}>
                                                                            <i className="fa fa-eye m-r-5"></i> View</Link>
                                                                        <Link className="dropdown-item" to="#" onClick={() => changeEmail({ employeeId: employee.id})}>
                                                                            <i className="fa fa-pencil m-r-5"></i> Change Email</Link>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="9" className="text-center">No records found</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>          
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Pagination pageCount={pageCount} handlePageClick={handlePageClick}/>
            </div>

            <ViewEmployees  list={fetchEmployees} employeeId={employeeId} />
        </>
    );
}

export default InactiveEmployees